/** Global picker sources shared by the Activity editor — currency + country.
 *
 * Hand-authored wrapper (console convention: never depend on generated types
 * for feature modules). `/currencies/` and `/countries/` are global lookups
 * (not tenant-scoped), consumed by `RemoteAutocomplete` (which extracts
 * `.results` before handing options to the widget).
 */
import { apiGet } from './client';

/** A currency option — `GET /currencies/?q=` → `{results: Currency[]}`. */
export interface Currency {
  id: number;
  code: string;
  name: string;
  symbol: string;
}

export function listCurrencies(q?: string): Promise<{ results: Currency[] }> {
  const qs = q ? `?q=${encodeURIComponent(q)}` : '';
  return apiGet(`/currencies/${qs}`);
}

// Country picker: reuse the existing `/countries/` helper + type from regions.
export { listCountries, type Country } from './regions';
